import { useState } from 'react'
import { brothersStatement } from '@/data/brothersStatement'

const BrothersStatement = () => {
  const [expanded, setExpanded] = useState(false)

  return (
    <article className="max-w-3xl border-l-2 border-red-700/80 pl-5 md:pl-8 py-1">
      <h2 className="font-bebas text-4xl md:text-6xl text-red-600 tracking-wide mb-5">
        Brothers’ Statement
      </h2>
      <p className="font-poppins text-xs uppercase tracking-[0.25em] text-red-600 mb-4">
        A statement from Jared &amp; André
      </p>
      <div className="space-y-5 font-poppins text-[15px] md:text-base leading-7 md:leading-8 text-neutral-300">
        {brothersStatement.slice(0, expanded ? brothersStatement.length : 1).map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
      <button
        type="button"
        aria-expanded={expanded}
        onClick={() => setExpanded((value) => !value)}
        className="mt-6 inline-flex items-center gap-3 font-poppins text-sm uppercase tracking-[0.16em] text-white hover:text-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-red-600 transition-colors"
      >
        <span>{expanded ? 'Read less' : 'Read more'}</span>
        <span aria-hidden="true" className="text-red-600">{expanded ? '−' : '+'}</span>
      </button>
    </article>
  )
}

export default BrothersStatement
